import { Component, OnInit } from '@angular/core';
import { StepService } from '../../stepper/step.service';

@Component({
  selector: 'app-add-passenger',
  templateUrl: './add-passenger.component.html',
  styleUrls: ['./add-passenger.component.scss']
})
export class AddPassengerComponent implements OnInit {

  constructor(private stepService: StepService) { }

  ngOnInit(): void {
  }

  yes() {
    this.stepService.nextStep();
  }

  no() {
    this.stepService.changeStep(9);
  }

}
